// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal__Modal__3Zzob","animation":"Modal__animation__3A1CJ"};